<mat-form-field class="text-field-input">
	<input matInput [autocomplete]="'3453'" [(ngModel)]="value" [type]="type" [placeholder]="title" (focusin)="onFocusIn()" (focusout)="onFocusOut()" (keypress)="onKeyPress($event)" [maxlength]="maxLength" [mask]="mask">
</mat-form-field>